import { BaseApiRequest } from '@api/BaseApi';
import moment from 'moment-timezone';
import { DATE_FORMAT, DATE_TIMEZONE_FORMAT } from '@constants/index';
import { getOffset } from '@api/helpers';
import { logError } from './Logging';

export const fetchDayReportData = (signal, { selectedRig, reportDate, well = null }) => {
  const queryParams = new URLSearchParams({
    rigname: selectedRig.rigName,
    rigId: selectedRig.rigId,
    reportdate: reportDate ? moment(reportDate).format(DATE_FORMAT) : '',
    wellname: well ?? ''
  });
  return BaseApiRequest(signal, `/DrillingActivities/GetDDRData?${queryParams.toString()}`, 'gpr', 'GET')
  .catch((error) => {
    if (!signal?.aborted) {
      logError(error, 'Failed to retrieve DDR Data.');
    }
  });
};

export const fetchHourReportData = (
  signal,
  { selectedRig, startDate, endDate, well = null }
) => {
  const queryParams = new URLSearchParams({
    rigname: selectedRig.rigName,
    rigId: selectedRig.rigId,
    startdate: startDate ?? '',
    enddate: endDate ?? '',
    wellname: well ?? '',
    offset: getOffset(startDate)
  });
  return BaseApiRequest(signal, `/DrillingActivities/GetWellEvents?${queryParams.toString()}`, 'gpr', 'GET')
  .catch((error) => {
    if (!signal?.aborted) {
      logError(error, 'Failed to retrieve Well Events.');
    }
  });
};

export const fetchRigWells = (signal, { startDate, endDate, selectedRig }) => {
  const queryParams = new URLSearchParams({
    rigname: selectedRig.rigName,
    startdate: startDate ?? '',
    torigtimezone: true,
    enddate: endDate ?? ''
  });
  return BaseApiRequest(signal, `/DrillingActivities/GetWells?${queryParams.toString()}`, 'gpr', 'GET')
  .then(async (result) => {
    result = (result ?? []).map(well => {
      var endTime = moment.parseZone(well.endtime);
      var startOfDay = endTime.clone().startOf("day");

      if(endTime.isSame(startOfDay)) {
        endTime = endTime.subtract(1, "days").endOf("day");
      }
      return ({
      ...well,
      endtime: endTime.format(DATE_TIMEZONE_FORMAT)
    })});

    return result;
  })
  .catch((error) => {
    if (!signal?.aborted) {
      logError(error, 'Failed to retrieve Rig Wells.');
    }
  });
};
